<script setup lang="ts">
const t2 = useT2({
  'Search products': 'Ieškoti prekių',
  'Search B2B products': 'Ieškoti didmenos prekių',
})
const { query, loading, searchUi, querySet, isB2B } = useAppSearch()
const label = computed(() => (isB2B.value ? t2('Search B2B products') : t2('Search products')))

const props = defineProps<{
  onFocus?(): void
  onInput(): void
}>()

const autofocus = false

const elem = useTemplateRef('elem')
const isFocused = ref(false)

function blur() {
  helpers.getHTMLElement(elem.value)?.blur()
  isFocused.value = false
}

function search() {
  if (isB2B.value) navigateTo(searchUi.value.toSearch({ query: query.value }))
  else navigateTo(searchUi.value.toSearch({ query: query.value }))
}

function clear() {
  querySet('')
  nextTick(() => helpers.getHTMLElement(elem.value)?.focus())
}

function onInput2(e: Event) {
  querySet(myInputValue(e, (i) => helpers.toString(i)))
  props.onInput()
}

function doFocus() {
  isFocused.value = true
  props.onFocus?.()
}

// useDelayInit(() => {
//   if (props.autofocus) focus(100)
// })

defineExpose({ blur })
</script>

<template>
  <div :class="[$style.navInput, isFocused && $style.navInputOn]">
    <div :class="$style.fill" />
    <div :class="$style.border" />

    <button type="button" aria-label="Search" :class="$style.searchIcon" @click="search">
      <IconSearch class="_svg16" />
    </button>

    <input
      ref="elem"
      :value="query"
      :class="$style.inp"
      :placeholder="label"
      name="search"
      maxlength="100"
      autocomplete="off"
      role="combobox"
      aria-label="Search through site content"
      aria-required="true"
      type="search"
      aria-expanded="false"
      aria-haspopup="listbox"
      aria-controls="search-results"
      :autofocus="autofocus"
      @keyup.enter.passive="search"
      @input.passive="onInput2"
      @focus.passive="doFocus"
    />

    <ButtonIcon v-if="query" :class="$style.end" :txt="t2('Clear')" size="18" @click="clear" />
    <div v-if="loading" :class="$style.end">
      <UiLoading :class="$style.loading" />
    </div>
  </div>
</template>

<style module>
.loading {
  composes: global(_absolute);
  left: -4px;
  top: -4px;
}
.navInput {
  composes: global(_relative);
  composes: global(_row);
  composes: global(_h34);
  composes: global(_w220);
  composes: global(_mr2);
  composes: global(_hidden);
  composes: global(_flex);
  composes: global(_mt02);

  composes: global(_c1);
  composes: global(_endA);

  transition: width 100ms var(--tran2);
  z-index: 1;
}

.navInputOn {
  composes: global(_h44);
  width: 720px;
  border-radius: 14px 0 0 0;
}

.fill {
  composes: global(_br14);
  composes: global(_absolute);
  composes: global(_inset);
  transform-origin: top right;
  transition: transform 0.3s var(--tran2);
}

.navInputOn .fill {
  transform: scale(1);
  background: var(--bg);
  /* border: 1px solid var(--black); */
  border: 1px solid hsl(40, 15%, 92%);
}

.border {
  composes: global(_absolute);
  composes: global(_inset);
  composes: global(_br99);

  /* TODO CSS */
  border: 1px solid var(--black);
  transition: border-color 150ms var(--tran2);
}

.navInputOn .border {
  opacity: 0;
}

.end {
  composes: global(_absolute);
  right: 4px;
  bottom: 9px;
}

.clearOn {
  visibility: visible;
}

.inp {
  composes: global(_fs1);
  composes: global(_relative);
  composes: global(_h100p);

  align-self: stretch;
  background: transparent;
  border: 0;
  color: inherit;
  cursor: text;
  flex: 9999 0 auto;
  outline: none;
  color: var(--blue2);
  caret-color: var(--blue2);

  composes: global(_pt04);
  composes: global(_pl04);
}
.inp::placeholder,
.inp:placeholder-shown {
  font-family: inherit;
  font-weight: var(--fw-l);
  color: var(--black);
  font-size: var(--fs-1);
  letter-spacing: var(--ls-xs);
  opacity: 1;
}

.inp::selection {
  background: var(--black);
  color: var(--bg);
}
.searchIcon {
  composes: global(_relative);
  composes: global(_br99);
  composes: global(_ctr);
  composes: global(_hidden);
  composes: global(_svg);
  composes: global(_mta);
  composes: global(_mba);
  --svg: 30px;

  composes: global(_c1);

  background: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
}
.searchIcon svg {
  z-index: 2;
  position: relative;
}

.searchIcon::after {
  content: '';
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: hsl(220 10% 80%);
  margin: auto;
  opacity: 0.01;
  transition: all 80ms ease-in;
  transform: scale(0.7);
  z-index: 1;
}

.searchIcon:hover::after {
  opacity: 0.35;
  transform: scale(1);
}
.searchIcon:hover:active svg {
  transform: scale(0.94);
}
</style>
